var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___Tm9xYz",
  "pG": "ChannelOverviewTab.module__regionEmoji___Tm9xYz",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___Tm9xYz",
  "c5": "ChannelOverviewTab.module__topicInput___Tm9xYz",
  "Z8": "ChannelOverviewTab.module__emojiButton___Tm9xYz",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___Tm9xYz",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___Tm9xYz",
  "p9": "ChannelOverviewTab.module__sectionWrapper___Tm9xYz",
  "h3": "ChannelOverviewTab.module__settingsGroup___Tm9xYz",
  "hB": "ChannelOverviewTab.module__settingsControlRow___Tm9xYz",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___Tm9xYz",
  "Y4": "ChannelOverviewTab.module__settingsControlText___Tm9xYz",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___Tm9xYz",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___Tm9xYz",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___Tm9xYz",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___Tm9xYz",
};

module.exports = exports;
